export enum ActionMatchType {
    custom = 'CUSTOM',
    insured = 'INSURED',
    relyingParty = 'RELYING_PARTY',
}
